import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { BASE_API_URL, BASE_FMBANAGER_API_URL } from 'config';

import { baseQueryWithReauth } from './baseQueryWithAuth';

const baseQuery = fetchBaseQuery({
  baseUrl: BASE_API_URL,
  prepareHeaders: (headers) => {
    const TOKEN = localStorage.getItem('token');
    if (TOKEN) {
      headers.append('Authorization', `Bearer ${TOKEN}`);
    }
    return headers;
  },
  paramsSerializer: (params) => {
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (Array.isArray(value)) {
        value.forEach((item) => searchParams.append(key, item));
      } else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        searchParams.append(key, value.toString());
      }
    }
    return searchParams.toString();
  },
});

const baseQueryFB = fetchBaseQuery({
  baseUrl: BASE_FMBANAGER_API_URL,
  prepareHeaders: (headers) => {
    const TOKEN = localStorage.getItem('token');
    if (TOKEN) {
      headers.append('Authorization', `Bearer ${TOKEN}`);
    }
    return headers;
  },
});

export const api = createApi({
  baseQuery: baseQueryWithReauth(baseQuery),
  keepUnusedDataFor: 0.0001,
  tagTypes: [
    'Affiliates',
    'Calendar',
    'Candidates',
    'Costs',
    'Domains',
    'MyDomains',
    'Gallery',
    'Job',
    'Leads',
    'Offers',
    'Persons',
    'Store',
    'Tasks',
    'TasksAnswers',
    'TasksComments',
    'Teams',
    'Trackers',
    'Transits',
    'User',
    'Users',
    'ViaBalance',
    'Videos',
  ],
  endpoints: () => ({}),
});

export const fbApi = createApi({
  baseQuery: baseQueryWithReauth(baseQueryFB),
  reducerPath: 'fbmanagerApi',
  tagTypes: ['FBmanager', 'Check-Proxy', 'Rules', 'Proxy', 'Comments', 'Settings'],
  endpoints: () => ({}),
});

export const CACHE_TTL = 60;
